(function () {
    'use strict';

    /**
        * @ngdoc service
        * @name swif.carto.swifCartoService
        * @description this is a facade to all services inside swif.carto
        *
        * ```js
          {
            leaflet
          }```
        * @requires  swif.carto.swifCartoLeafletService
    **/
    class swifCartoService {
        constructor(swifCartoLeafletService, osmAPI, osmtogeojson) {
            this.leaflet = swifCartoLeafletService;
            // osmAPI & osmtogeojson libs come from osm-angular
            this.osmAPI = osmAPI;
            this.osmtogeojson = osmtogeojson;
        }
    }
    swifCartoService.$inject = ['swifCartoLeafletService', 'osmAPI', 'osmtogeojson'];

    angular.module('base64', [])
    .service('$base64', function () {});

    angular.module('swif.carto')
    .service('swifCartoService', swifCartoService);

})();
